/* src/app/_shared/components/menu-button/menu-button.component.scss */
:host {
  display: block;
  margin-left: calc(var(--space-left) / 2);
}
@media only screen and (min-width: 992px) {
  :host {
    display: none;
  }
}
app-toolbar-button {
  --icon-font-size: 26px;
}
/*# sourceMappingURL=menu-button.component.css.map */
